import Disclaimer from '../components/Disclaimer'
import { Link } from 'react-router-dom'
import Navigation from '../components/Navigation'
import { usePageTitle } from '../hooks/usePageTitle'

const AccessibilityStatementPage = () => {
    usePageTitle('Accessibility Statement');
    return (
        <div id="body" className="page-template-default page page-id-259 wp-embed-responsive accessibility-statement geo-az bid-60">
            <Disclaimer />
            <Navigation />
            <main>
                <section id="intro" className="w-full relative flex items-center min-h-[134px]  bg-hero ">
                    <div className="hero my-auto flex flex-row items-center">
                        <div className="z-[1] flex-1 container">
                            <div className="py-[24px] sm:py-[32px]">
                                <h1 className="leading-[40px] text-[34px] sm:leading-[40px] font-semibold text-[#323738] m-0">
                                    Accessibility Statement
                                </h1>
                                <div
                                    className="text-[#323738] mt-[8px] text-[14px] leading-[20px] sm:text-[16px] md:leading-[20px] lg:leading-[24px] ">

                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <div id="content-area" className="container legal-page !mt-[20px]">
                    <p>Ryze Beyond Ltd. (“Company“) endeavors to make its website, available at: <Link
                        htoref="/"> casinonlineireland.site</Link> (“website“), accessible for
                        people with disabilities.
                        Web accessibility is at the core of the Company’s values; therefore, we are continually improving the
                        website and working on making it available to many people as possible,
                        while ensuring compliance with the relevant accessibility standards by using different functions such
                        as:</p>
                    <ul>
                        <li>Change colors, contrast levels and fonts;</li>
                        <li>Screen reader in various speeds;</li>
                        <li>Navigate most of the website using just a keyboard.</li>
                    </ul>
                    <p>We’ve also made the website text as simple as possible to understand.</p>
                    <h4>WHAT IS WEBSITE ACCESSIBILITY?</h4>
                    <p>An accessible website is a website that enables people with disabilities to browse with the same level of
                        efficiency and enjoyment as other website visitors.</p>
                    <h4>COMPLIANCE STATUS OF THIS WEBSITE’S ACCESSIBILITY</h4>
                    <p>The accessibility adjustments on this website were carried out in compliance with the global <a
                        href="https://www.w3.org/TR/WCAG21/" target="_blank" rel="noreferrer">WCAG 2.1</a> guidelines at the AA level, as
                        well as applicable legislation. Most pages on this website meet AA level accessibility criteria. </p>
                    <p>As part of our accessibility efforts, we placed an accessibility widget on the right side of the website,
                        in order to provide a verity of accessibility modifications, which includes the following functions:
                    </p>
                    <ul>
                        <li>Screen reader enabling users to consume the same content in an audio format rather in text;</li>
                        <li>Enable keyboard navigation (for example, you can navigate forward on the website using the TAB
                            button. To navigate back, press the SHIFT + TAB key combination) and voice navigation;</li>
                        <li>Fonts – Ability to increase and decrease the site font, adjust, align etc.;</li>
                        <li>Change color contrast based on dark background;</li>
                        <li>Change color contrast based on a light background;</li>
                        <li>Change the website’s colors;</li>
                        <li>Matching and monochrome option for color blind people;</li>
                        <li>Change the font for readability;</li>
                        <li>Increase the cursor and change its color to black or white;</li>
                        <li>Increase the font size;</li>
                        <li>Highlight links on the website;</li>
                        <li>Hide images</li>
                        <li>Increase the content chosen by the cursor, showed in a tooltip;</li>
                        <li>Describe words by mouse selection;</li>
                    </ul>
                    <h4>Technical Specifications:</h4>
                    <p>The accessibility of this website relies on the following technologies to work with the particular
                        combination of web browser and any assistive technologies or plugins installed on your computer:</p>
                    <ul>
                        <li>HTML</li>
                        <li>WAI-ARIA</li>
                        <li>CSS</li>
                        <li>JavaScript</li>
                    </ul>
                    <p>These technologies are relied upon for conformance with the accessibility standards used.</p>
                    <h4>Compatibility with browsers:</h4>
                    <p>We strive to be able to support the popular browsers with high market share, including: </p>
                    <ul>
                        <li>Edge</li>
                        <li>Chrome</li>
                        <li>Firefox</li>
                        <li>Opera</li>
                        <li>Safari</li>
                    </ul>
                    <h4>Use of Third-Party Sites & Components:</h4>
                    <p>Some third-party components or links that are used on the website, such as Facebook, Instagram, YouTube,
                        Twitter, chats, and others, which are not controlled by us, may present challenges for individuals with
                        disabilities that we are not able to remedy. Such third-party components are governed by third parties’
                        accessibility policies, such as:</p>
                    <ul>
                        <li><a href="https://www.facebook.com/help/273947702950567" target="_blank" rel="noreferrer">Facebook Accessibility
                            Policy</a></li>
                        <li><a href="https://support.google.com/youtube/answer/189278?hl=en" target="_blank" rel="noreferrer">YouTube
                            Accessibility Policy</a></li>
                        <li><a href="https://help.instagram.com/1178723545597542" target="_blank" rel="noreferrer">Instagram Accessibility
                            Policy</a></li>
                        <li><a href="https://help.instagram.com/1178723545597542" target="_blank" rel="noreferrer">Twitter Accessibility
                            Policy</a></li>
                        <li><a href="https://help.instagram.com/1178723545597542" target="_blank" rel="noreferrer">LinkedIn Accessibility
                            Policy</a></li>
                    </ul>
                    <p>It is important to note that despite our ongoing efforts to make the website and services accessible,
                        parts or certain features of the website might not yet be fully adjusted, and are non-compliance with
                        the accessibility regulations.</p>
                    <p>The content listed below is non-accessible for the following reasons:</p>
                    <ul>
                        <li>Some of our PDFs documents are difficult to navigate using a keyboard. For example, we have DSR Form
                            with information on users’ privacy rights and how they can exercise any rights subject to their
                            jurisdiction. We’ve assessed the cost of fixing the issues with navigation and accessing
                            information, and with interactive tools and transactions. We believe that doing so now would be a <a
                                href="https://help.instagram.com/1178723545597542" target="_blank" rel="noreferrer">disproportionate burden</a>
                            within the meaning of the accessibility regulations. </li>
                    </ul>
                    <h4>CONTACT INFORMATION FOR ERRORS, INACCESSIBLE CONTENT, INQUIRIES AND SUGGESTIONS.</h4>
                    <p>It is possible that some pages or sections on this website have human mistakes, for a variety of reasons.
                        Therefore, we’d be happy to hear any feedback about accessibility problem! Please send us email to: [<a
                            href="mailto:service@casinonlineireland.site"
                            target="_blank" rel="noreferrer">service@casinonlineireland.site</a>] with any problem or suggestions you encounter
                        while using the website, we will do our best efforts to solve the problem and maintain the website at
                        the best level.</p>
                    <p>In addition, if you need information on this website in a different format like accessible PDF, large
                        print, easy read, audio recording, etc. – please contact us as detailed below.</p>
                    <p>In order to enable us to handle any issues, please include, as much as possible, complete details, and
                        contact us at:<br />
                        By email: [<a href="mailto:service@casinonlineireland.site"
                            target="_blank" rel="noreferrer">service@casinonlineireland.site</a>]<br />
                        By phone: [1 (800) 406-6210]<br />
                        By mail: Yitzhak Sade 8, Tel-Aviv, Israel
                    </p>
                    <p>Please include a description of the applicable error, issue or problem, what is the action you tried to
                        perform, which page did you browse, what is your operating system, browser type and version, as well as
                        the type of assistive technology (if you used it).</p>
                    <p>We aim to respond to accessibility feedback within 7 business days, and to propose a solution within 30
                        business days.</p>
                    <p>
                        This statement was prepared on June 04, 2023. It was last reviewed on June 04, 2023.<br />
                        This website was last tested on June 04, 2023.
                    </p>
                </div>
            </main>
        </div>
    )
}

export default AccessibilityStatementPage